<template>
  <div class="container">
    <div class="nban pc">
      <img src="@/view/images/y22.jpg" />
      <div class="nbana">
        <p>
          <router-link to="/solution2?navaa=1">蜂享优印解决方案</router-link>
        </p>
        <p>
          <router-link to="/solution1?navaa=1"
            >印刷数字化工厂解决方案</router-link
          >
        </p>
        <p class="on">
          <router-link to="/solution?navaa=1">印刷管家服务解决方案</router-link>
        </p>
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- <div class="mbx pc">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">解决方案</a></p>
      </div>
    </div> -->
    <!--印刷管家服务解决方案-->
    <div class="neiy">
      <div class="commen">
        <div class="nbana mob">
          <p class="">
            <router-link to="/solution2?navaa=1">蜂享优印解决方案</router-link>
          </p>
          <p>
            <router-link to="/solution1?navaa=1"
            >印刷数字化工厂解决方案</router-link
            >
          </p>
          <p class="on">
            <router-link to="/solution?navaa=1"
              >印刷管家服务解决方案</router-link
            >
          </p>
          <div class="clearfix"></div>
        </div>
        <div class="fa1a">
          <div class="bt reveal-scaletop">
            <h6>印刷管家服务解决方案</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa1aa reveal-scaletop">
            <p>您是否受以下问题困扰？</p>
            <img src="@/view/images/y30-2.png" />
          </div>
          <div class="fa1ab">
            <div class="fa1ac fl reveal-left">
              <img class="ta" src="@/view/images/y23-2.png" />
              <img class="tb" src="@/view/images/y31.png" />
              <p>设备足够多，理论产能很大<br />为什么还是不能按时交货？</p>
            </div>
            <div class="fa1ac fl reveal-scaletop">
              <img class="ta" src="@/view/images/y24-2.png" />
              <img class="tb" src="@/view/images/y31.png" />
              <p>
                设备、材料、人员，墨量数据不变<br />加印时还要改版校色，为什么？
              </p>
            </div>
            <div class="fa1ac fl reveal-right">
              <img class="ta" src="@/view/images/y25-4.png" />
              <img class="tb" src="@/view/images/y31.png" />
              <p>返单追客户样，反复改版校色<br />机台一天才打一个样</p>
            </div>
            <div class="fa1ac fl reveal-right">
              <img class="ta" src="@/view/images/y25-3.png" />
              <img class="tb" src="@/view/images/y31.png" />
              <p>
                花钱请人做色彩管理，老师一走<br />三个月都无法保持，为什么？
              </p>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="fa1b">
          <div class="bt reveal-scaletop">
            <h6>印刷管家服务解决方案</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa1ba reveal-scaletop">
            <p>
              建立印前、印刷全流程的色彩管理体系，重点解决色差问题，让印刷机变身高级复印机。<br />通过色彩管理体系建立、标准化作业培训、印刷机状态维护、质量评测方法建立、<br />印刷管家服务APP及线上线下的管家服务技术支持，提升色彩管理和标准化作业水平。
            </p>
          </div>
          <div class="fa1bb">
            <div class="fa1bb_a fl reveal-left">
              <h5 style="color: #FE7E56;text-indent: -20px;">
                <img style="display: inline-block" src="@/view/images/icon-circle.png">
                润版液pH值、电导率、温度实时监测
              </h5>
              <div class="fa1bb_aa pd15">
                <p class="indent-text">① 设备自动抓取润版液关键参数，数据上云，手机端可查看</p>
                <p class="indent-text">② 参数超标，实时报警给机长/生管，便于及时处理</p>
                <p class="indent-text">③ 统计原因，为针对性解决问题提供数据支撑</p>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="fa1bb_a fr reveal-right">
              <h5 style="color: #FE7E56;text-indent: -20px;">
                <img style="display: inline-block" src="@/view/images/icon-circle.png">
                设备维保自动推送和点检
              </h5>
              <div class="fa1bb_aa pd15">
                <p class="indent-text">① 设备日、周、月、季、年维保策略自动推送给保养人员</p>
                <p class="indent-text">② 专人点检评分，形成管理闭环</p>
                <p class="indent-text">③ 维保执行情况排名自动统计，上报领导</p>
                <p class="indent-text">④ 故障维修一键提报，处理结果自动统计</p>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="fa1bb_a fl fa1bb_b reveal-left">
              <h5 style="color: #FDA951;text-indent: -20px;">
                <img style="display: inline-block" src="@/view/images/icon-circle.png">
                线下专业技术团队，帮助客户建立标准化的四大体系
              </h5>
              <div class="fa1bb_aa pd15">
                <p class="indent-text">① 建立印刷设备和材料的标准化和规范化质量控制体系</p>
                <p class="indent-text">② 建立印刷色彩标准化和规范化质量控制体系</p>
                <p class="indent-text">③ 再造印刷生产工艺流程和生产作业体系</p>
                <p class="indent-text">④ 应用数字化技术培育和再造人才管理体系</p>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="fa1bb_a fr fa1bb_b reveal-right">
              <h5 style="color: #FDA951;text-indent: -20px;">
                <img style="display: inline-block" src="@/view/images/icon-circle.png">
                打油润滑，智能管控
              </h5>
              <div class="fa1bb_aa pd15">
                <p class="indent-text">① 每个润滑点位，贴有智能芯片</p>
                <p class="indent-text">
                  ② 智能油枪、油壶在打油润滑时，靠近芯片，自动记录保养动作并上传
                </p>
                <p class="indent-text">③ 避免因遗漏打油润滑点位造成的印剧机磨损等不可逆损失</p>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="fa1bb_a fl fa1bb_b reveal-left">
              <h5 style="color: #FE7E56;text-indent: -20px;">
                <img style="display: inline-block" src="@/view/images/icon-circle.png">
                有效生产时间（时间稼动率）及异常待机自动统计
              </h5>
              <div class="fa1bb_aa pd15">
                <p class="indent-text">
                  ① 每台印刷机安装智能数据采集器，实时自动抓取有效印刷时间并上报
                </p>
                <p class="indent-text">
                  ②
                  自动抓取异常待机时间，由机台人员填报原因，汇总上报领导，帮助用户快速定位潜在问题，及时解决，提升有效印刷时间
                </p>
                <p class="indent-text">③ 历史数据及变化趋势一目了然</p>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="fa1bb_a fr fa1bb_b reveal-right">
              <h5 style="color: #FE7E56;text-indent: -20px;">
                <img style="display: inline-block" src="@/view/images/icon-circle.png">
                印刷机水墨平衡状态每月评测
              </h5>
              <div class="fa1bb_aa pd15">
                <p class="indent-text">① 印工社提供水墨平衡版文件给客户</p>
                <p class="indent-text">
                  ②
                  客户每月印刷一次约200张，按要求使用印工社PQES印刷质量评测系统测量数据并上传
                </p>
                <p class="indent-text">
                  ③
                  自动统计放墨精度，印刷主管根据结果进行放墨曲线优化，减少印刷机校版调色损耗
                </p>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="fa1bb_a fl fa1bb_c reveal-left">
              <h5 style="color: #FDA951;text-indent: -20px;">
                <img style="display: inline-block" src="@/view/images/icon-circle.png">
                设备达产率（性能稼动率）自动统计上报
              </h5>
              <div class="fa1bb_aa pd15">
                <p class="indent-text">
                  ①
                  每台印刷机安装智能数据采集器，实时自动抓取产量，计算设备达产率（性能稼动率）并上报
                </p>
                <p class="indent-text">② 自动统计上报客机台、班次设备达产率</p>
                <p class="indent-text">③ 历史数据及变化趋势一目了然</p>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="fa1bb_a fr fa1bb_c reveal-right">
              <h5 style="color: #FDA951;text-indent: -20px;">
                <img style="display: inline-block" src="@/view/images/icon-circle.png">
                印刷机色彩质量每日评测
              </h5>
              <div class="fa1bb_aa pd15">
                <p class="indent-text">① 要求每天至少一个活件能印刷出测控条</p>
                <p class="indent-text">② 印刷机台人员使用印工社PQS印刷质量评测系统测量数据并上传</p>
                <p class="indent-text">
                  ③
                  自动统计各机台质量评分趋势，相关人员根据数据优化补偿曲线，追标准更简单，可以每天达到gm要求
                </p>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="fa1bc"><img src="@/view/images/y26-2.png" /></div>
          </div>
        </div>
      </div>
      <div class="fa1c">
        <div class="commen">
          <div class="bta reveal-scaletop">
            <h6>印刷管家服务APP</h6>
            <img src="@/view/images/y32.png" />
          </div>
          <div class="fa1ca reveal-scaletop">
            <h6>下载您的印刷管家，把工厂装在口袋帶回家！</h6>
            <p>印刷工厂数据可视化，直观查看OEE</p>
            <p>实时查看设备有效工作比、时间稼动率、性能</p>
            <p>及时检测排查隐患，工厂运转情况尽在掌握</p>
            <p>培训赋能，助力印刷企业建立生产质量闭环管理体系</p>
            <p>课程培训+在线指导+上门服务 三位一体为印刷生产保驾护航</p>
          </div>
        </div>
      </div>
      <div class="fa1d">
        <div class="commen">
          <div class="bt reveal-scaletop">
            <h6>系统硬件</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa1da pc fa1show">
            <el-carousel
              ref="fa1show"
              class="cardShowban"
              height="600px"
              :loop="true"
              indicator-position="none"
              :interval="5000"
              arrow="never"
            >
              <el-carousel-item>
                <div class="fa1db">
                  <div class="fa1dc fl">
                    <div class="fa1dx">
                      <div class="fa1da_t">
                        <img src="@/view/images/y28.jpg" />
                      </div>
                      <div class="fa1da_w">
                        <h6>印刷样张质量评测系统</h6>
                        <p>
                          印刷样张质量评测系统由评测系统硬件和评测系统软件组成。<br /><span
                            >⊙</span
                          >5-10秒完成印刷质量相关数据采集<br /><span>⊙</span
                          >放墨精度、印刷质量（密度、色度、网点扩大等）数据一目了然
                        </p>
                        <img src="@/view/images/y21.png" />
                      </div>
                      <div class="fa1da_x">
                        <h6>印刷样张质量评测系统</h6>
                        <p>
                          印刷样张质量采集系统由采集系统硬件和评测系统软件组成。
                          <br /><span>⊙</span>5-10秒完成印刷质量相关数据采集
                          <br /><span>⊙</span>适用于各种尺寸纸张 <br /><span
                            >⊙</span
                          >数据自动分析，实时控制 <br /><span>⊙</span
                          >依标准印刷，高效迅速 <br /><span>⊙</span
                          >大屏显示，数据上传，APP同步 <br /><span>⊙</span
                          >生产更高效，管理更直观，数据可追踪 <br /><span
                            >⊙</span
                          >放墨精度、印刷质量（密度、色度、网点扩大等）数据一目了然

                          <br /><br />主要功能：
                          <br />自动测量印刷样张质量测控条；
                          <br />自定义印刷目标及评分标准；
                          <br />自动生成印刷质量评测报告；
                          <br />提供各墨区墨量调整参考值；
                          <br />可在APP查看上传的质量数据。

                          <br /><br />印刷质量数据化，是印刷企业实施标准化的基础
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="fa1dc fl">
                    <div class="fa1dx">
                      <div class="fa1da_t">
                        <img src="@/view/images/y29.jpg" />
                      </div>
                      <div class="fa1da_w">
                        <h6>印前追色看样系统</h6>
                        <p>
                          印前追色看样系统是一套集成标准看样光源、屏幕软打样、色表测量平台以及印工社返单追样系统的综合平台。<br /><span
                            >⊙</span
                          >颜色评测，观察标准平台
                        </p>
                        <img src="@/view/images/y21.png" />
                      </div>
                      <div class="fa1da_x">
                        <h6>印前追色看样系统</h6>
                        <p>
                          印前追色看样平台是一套集成标准看样光源、屏幕软打样、色表测量平台以及印工社返单追样系统的综合系统。
                          <br /><span>⊙</span>颜色评测与分析标准观察平台
                          <br /><span>⊙</span>高效追样，提升效率 <br /><span
                            >⊙</span
                          >快速完成色表测量及ICC特性文件生成 <br /><span>⊙</span
                          >数字化、标准化印前必备神器 <br /><span>⊙</span
                          >软打样精确模拟印刷，实现“所见即所得”

                          <br /><br />主要功能：
                          <br />D50/D60标准观察环境，用于评测印刷品；
                          <br />经过校正的专业显示器，可实现屏幕软打样；
                          <br />色表自动扫描平台用于自动扫描印刷色表，生成ICC特性文件或进行色彩分析；
                          <br />经过校正的扫描平台可用于获取客户样、印刷样、数码样的数据；
                          <br />返单追样系统自动分析实物样与印厂数码样、印刷样或原文件区别，自动生成色彩校正曲线，快速完成印前校色、调图。

                          <br /><br />追样被当成“难题”的日子一去不复返了
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="fa1dc fl">
                    <div class="fa1dx">
                      <div class="fa1da_t">
                        <img src="@/view/images/y30.jpg" />
                      </div>
                      <div class="fa1da_w">
                        <h6>CTP印版网点质量评测系统</h6>
                        <p>
                          CTP印版网点质量评测系统由高速网点采集系统硬件和评测软件组成，用于评测和保证CTP印刷制版网点的质量。
                        </p>
                        <img src="@/view/images/y21.png" />
                      </div>
                      <div class="fa1da_x">
                        <h6>CTP印版网点质量评测系统</h6>
                        <p>
                          CTP印版网点质量评测系统由高速网点采集系统硬件和评测软件组成，用于评测和保证CTP印刷制版网点的质量。
                          <br /><span>⊙</span>规避印刷质量风险 <br /><span
                            >⊙</span
                          >CTP印刷制版环节的智能检测设备 <br /><span>⊙</span
                          >10-15秒内完成0%-100%网点测量 <br /><span>⊙</span
                          >数据实时上传云端 <br /><span>⊙</span
                          >手机APP实时查看制版情况 <br /><span>⊙</span
                          >网点数据波动一目了然

                          <br /><br />主要功能：
                          <br />通过CTP印版网点质量评测系统连接印版网点扫描设备，扫描测量印版网点控制条，获取印版网点数据用于印前制版的质量监控和校正；在测量完成后，测量数据将上传至云端，用户可在印刷管家APP中实时查看印版网点数据，掌握印前制版质量情况。

                          <br /><br />印版差之毫厘，印品谬以千里
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <!-- <el-carousel-item>
                <div class="fa1db">
                  <div class="fa1dc fl">
                    <div class="fa1dx">
                      <div class="fa1da_t"><img src="@/view/images/y28.jpg"></div>
                      <div class="fa1da_w">
                        <h6>色彩管理神器—印刷样张质量采集系统</h6>
                        <p>印刷样张质量采集系统由采集系统硬件和评测系统软件组成。<br><span>⊙</span>5-10秒完成印刷质量相关数据采集<br><span>⊙</span>放墨精度、印刷质量（密度、色度、网点扩大等）数据一目了然
                        </p>
                        <img src="@/view/images/y21.png">
                      </div>
                      <div class="fa1da_x">
                        <h6>色彩管理神器—印刷样张质量采集系统</h6>
                        <p>印刷样张质量采集系统由采集系统硬件和评测系统软件组成。
                          <br><span>⊙</span>5-10秒完成印刷质量相关数据采集
                          <br><span>⊙</span>放墨精度、印刷质量（密度、色度、网点扩大等）数据一目了然
                          <br><span>⊙</span>适用于各种尺寸纸张
                          <br><span>⊙</span>数据自动分析，实时控制
                          <br><span>⊙</span>新单、返单数据印刷，高效迅速
                          <br><span>⊙</span>大屏显示，数据上传，APP同步
                          <br><span>⊙</span>生产更高效，管理更直观，数据可追踪

                          <br><br>主要功能：
                          <br>自动测量印刷质量测控条；
                          <br>自定义印刷目标及评分；
                          <br>印刷质量评分自动生成；
                          <br>提供各墨区墨量调整参考值；
                          <br>可导出质量报告；
                          <br>可在APP查看上传的质量数据。

                          <br><br>印刷质量数据化，是印刷企业实施标准化的基础

                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="fa1dc fl">
                    <div class="fa1dx">
                      <div class="fa1da_t"><img src="@/view/images/y29.jpg"></div>
                      <div class="fa1da_w">
                        <h6>追样神器—印前追色看样平台</h6>
                        <p>印前追色看样平台是一套集成标准看样光源、屏幕软打样、色表测量平台以及印工社返单追样系统的综合平台。<br><span>⊙</span>颜色评测，观察标准平台</p>
                        <img src="@/view/images/y21.png">
                      </div>
                      <div class="fa1da_x">
                        <h6>印前追色看样平台</h6>
                        <p>印前追色看样平台是一套集成标准看样光源、屏幕软打样、色表测量平台以及印工社返单追样系统的综合平台。
                          <br><span>⊙</span>颜色评测，观察标准平台
                          <br><span>⊙</span>高效追样，提升效率
                          <br><span>⊙</span>快速完成色表测量及ICC特性文件生成
                          <br><span>⊙</span>数字化、标准化印前必备神器
                          <br><span>⊙</span>软打样精确模拟印刷，实现“所见即所得”

                          <br><br>主要功能：
                          <br>用户可以在该平台上使用标准光源观察印刷实物样稿，使用经过色彩管理校准的显示器进行软打样；可利用集成的色表测量平台获取色表数据，用于印刷曲线、ICC色彩特性文件等的制作；该平台集成的返单追样系统在进行实物样追色时，通过扫描实物样稿与原文件进行对比，自动计算返回供用户参考的颜色调整曲线，快速完成印前校色、调图。

                          <br><br>追样被当成“难题”的日子一去不复返了

                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="fa1dc fl">
                    <div class="fa1dx">
                      <div class="fa1da_t"><img src="@/view/images/y30.jpg"></div>
                      <div class="fa1da_w">
                        <h6>印版网点质量采集系统</h6>
                        <p>印版网点质量采集系统由高速网点采集系统硬件和评测软件组成，用于评测和保证印刷制版网点的质量。<br><span>⊙</span>规避印刷质量风险</p>
                        <img src="@/view/images/y21.png">
                      </div>
                      <div class="fa1da_x">
                        <h6>印版网点质量采集系统</h6>
                        <p>印版网点质量采集系统由高速网点采集系统硬件和评测软件组成，用于评测和保证印刷制版网点的质量。
                          <br><span>⊙</span>规避印刷质量风险
                          <br><span>⊙</span>印刷制版环节检测设备首选
                          <br><span>⊙</span>10秒内完成测量，数据实时上传
                          <br><span>⊙</span>一部手机就能查看制版情况
                          <br><span>⊙</span>网点数据波动一目了然

                          <br><br>主要功能：
                          <br>通过PDSS印版网点扫描系统连接印版网点扫描设备，扫描测量印版网点控制条，获取印版网点数据用于印前制版的质量监控；在测量完成后，将测量数据上传至绑定的印工社账号，可在印工社管家APP查看印版网点数据，掌握印前制版质量情况。

                          <br><br>制版失之毫厘，印品谬以千里

                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item> -->
            </el-carousel>
          </div>
          <!-- <div class="fa1da mob reveal-scaletop">
            <div class="swiper-container" id="swiper_fa1">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="fa1dx">
                    <div class="fa1da_t"><img src="@/view/images/y28.jpg"></div>
                    <div class="fa1da_w">
                      <h6>色彩管理神器—印刷样张质量采集系统</h6>
                      <p>印刷样张质量采集系统由采集系统硬件和评测系统软件组成。<br><span>⊙</span>5-10秒完成印刷质量相关数据采集<br><span>⊙</span>放墨精度、印刷质量（密度、色度、网点扩大等）数据一目了然
                      </p>
                      <img src="@/view/images/y21.png">
                    </div>
                    <div class="fa1da_x">
                      <h6>色彩管理神器—印刷样张质量采集系统</h6>
                      <p>印刷样张质量采集系统由采集系统硬件和评测系统软件组成。
                        <br><span>⊙</span>5-10秒完成印刷质量相关数据采集
                        <br><span>⊙</span>放墨精度、印刷质量（密度、色度、网点扩大等）数据一目了然
                        <br><span>⊙</span>适用于各种尺寸纸张
                        <br><span>⊙</span>数据自动分析，实时控制
                        <br><span>⊙</span>新单、返单数据印刷，高效迅速
                        <br><span>⊙</span>大屏显示，数据上传，APP同步
                        <br><span>⊙</span>生产更高效，管理更直观，数据可追踪

                        <br><br>主要功能：
                        <br>自动测量印刷质量测控条；
                        <br>自定义印刷目标及评分；
                        <br>印刷质量评分自动生成；
                        <br>提供各墨区墨量调整参考值；
                        <br>可导出质量报告；
                        <br>可在APP查看上传的质量数据。

                        <br><br>印刷质量数据化，是印刷企业实施标准化的基础

                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1dx">
                    <div class="fa1da_t"><img src="@/view/images/y29.jpg"></div>
                    <div class="fa1da_w">
                      <h6>追样神器—印前追色看样平台</h6>
                      <p>印前追色看样平台是一套集成标准看样光源、屏幕软打样、色表测量平台以及印工社返单追样系统的综合平台。<br><span>⊙</span>颜色评测，观察标准平台</p>
                      <img src="@/view/images/y21.png">
                    </div>
                    <div class="fa1da_x">
                      <h6>印前追色看样平台</h6>
                      <p>印前追色看样平台是一套集成标准看样光源、屏幕软打样、色表测量平台以及印工社返单追样系统的综合平台。
                        <br><span>⊙</span>颜色评测，观察标准平台
                        <br><span>⊙</span>高效追样，提升效率
                        <br><span>⊙</span>快速完成色表测量及ICC特性文件生成
                        <br><span>⊙</span>数字化、标准化印前必备神器
                        <br><span>⊙</span>软打样精确模拟印刷，实现“所见即所得”

                        <br><br>主要功能：
                        <br>用户可以在该平台上使用标准光源观察印刷实物样稿，使用经过色彩管理校准的显示器进行软打样；可利用集成的色表测量平台获取色表数据，用于印刷曲线、ICC色彩特性文件等的制作；该平台集成的返单追样系统在进行实物样追色时，通过扫描实物样稿与原文件进行对比，自动计算返回供用户参考的颜色调整曲线，快速完成印前校色、调图。

                        <br><br>追样被当成“难题”的日子一去不复返了

                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1dx">
                    <div class="fa1da_t"><img src="@/view/images/y30.jpg"></div>
                    <div class="fa1da_w">
                      <h6>印版网点质量采集系统</h6>
                      <p>印版网点质量采集系统由高速网点采集系统硬件和评测软件组成，用于评测和保证印刷制版网点的质量。<br><span>⊙</span>规避印刷质量风险</p>
                      <img src="@/view/images/y21.png">
                    </div>
                    <div class="fa1da_x">
                      <h6>印版网点质量采集系统</h6>
                      <p>印版网点质量采集系统由高速网点采集系统硬件和评测软件组成，用于评测和保证印刷制版网点的质量。
                        <br><span>⊙</span>规避印刷质量风险
                        <br><span>⊙</span>印刷制版环节检测设备首选
                        <br><span>⊙</span>10秒内完成测量，数据实时上传
                        <br><span>⊙</span>一部手机就能查看制版情况
                        <br><span>⊙</span>网点数据波动一目了然

                        <br><br>主要功能：
                        <br>通过PDSS印版网点扫描系统连接印版网点扫描设备，扫描测量印版网点控制条，获取印版网点数据用于印前制版的质量监控；在测量完成后，将测量数据上传至绑定的印工社账号，可在印工社管家APP查看印版网点数据，掌握印前制版质量情况。

                        <br><br>制版失之毫厘，印品谬以千里

                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="fa1da_an">
            <img class="fa1da_anz fl pc" src="@/view/images/y34.png" @click="arrowClick('left')">
            <p><a href="#">查看详情</a></p>
            <img class="fa1da_any fl pc" src="@/view/images/y35.png" @click="arrowClick('right')">
            <div class="clearfix"></div>
          </div> -->
        </div>
      </div>
      <div class="fa1e">
        <div class="commen">
          <div class="bt reveal-scaletop">
            <h6>系统软件</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="fa1ea pc">
            <div class="fa1eb fl reveal-scaletop">
              <div class="fa1eb_t">
                <img src="@/view/images/y35.jpg" />
                <p><span></span>印张质量采集系统</p>
              </div>
              <div class="fa1eb_w">
                <p>
                  印版网点扫描系统用于印刷环节，主要用于对印刷样张上测控条色彩数据的快速采集，可用于评测手动放墨/CIP3自动放墨精度及印刷品是否满足特定印刷规范。
                  <br />
                  <br /><b>特点</b>
                  <br />5-10秒完成对开幅面的样张扫描，数据实时上云，实现云监控。
                  <br />
                  <br /><b>应用场景</b> <br />印刷机CIP3放墨校正、印刷质量管理。
                </p>
              </div>
            </div>
            <!-- <div class="fa1eb fl reveal-scaletop">
              <div class="fa1eb_t">
                <img src="@/view/images/y31.jpg">
                <p><span></span>FPS文件预检系统</p>
              </div>
              <div class="fa1eb_w">
                <p>PDF文件预检是指对各种印前排版文件在输出前进行必要的检查，通过预检环节，可在早期发现文件中的输出陷阱并及时修正错误，避免由于印前制作不规范等原因导致严重的印刷质量事故，造成无谓的损失。
                  <br />
                  <br><b>应用场景</b>
                  <br>品牌商、客户、设计\排版人员、业务员、印前人员等
                  <br />
                  <br><b>功能</b>
                  <br>自动、快速完成印刷文件的预检工作，保证印前文件质量，减少文件出错概率。
                </p>
              </div>
            </div> -->
            <div class="fa1eb fl reveal-scaletop">
              <div class="fa1eb_t">
                <img src="@/view/images/y32.jpg" />
                <p><span></span>返单追样系统</p>
              </div>
              <div class="fa1eb_w">
                <p>
                  返单追样系统是一套辅助印前作业人员快速实现追样的软件系统
                  <br />
                  <br /><b>应用场景</b>
                  <br />1）企业建立印刷规范后，原有产品的返（翻）单追色；
                  <br />2）非标准客户样的印刷追色；
                  <br />3）不同印刷机台的印刷追色；
                  <br />4）不同印刷工艺的印刷追色。
                </p>
              </div>
            </div>
            <!-- <div class="fa1eb fl reveal-scaletop">
              <div class="fa1eb_t">
                <img src="@/view/images/y33.jpg">
                <p><span></span>专色追色系统</p>
              </div>
              <div class="fa1eb_w">
                <p>专色追色系统用于精确分析因各种印刷工艺问题导致的颜色变化并进行色彩校正补偿的追色系统。<br><br><b>应用场景</b><br>油墨干湿变化校正、专色追色校正、覆膜颜色变化校正、上光颜色变化校正。
                </p>
              </div>
            </div> -->
            <div class="fa1eb fl reveal-scaletop">
              <div class="fa1eb_t">
                <img src="@/view/images/y34.jpg" />
                <p><span></span>印版网点扫描系统</p>
              </div>
              <div class="fa1eb_w">
                <p>
                  印版网点扫描系统用于印前制版环节，主要用于CTP印版网点测控条的网点数据的快速测量。
                  <br />
                  <br /><b>特点</b>
                  <br />一次扫描快速完成批量网点数据测量，数据实时上云，实现云监控。
                  <br />
                  <br /><b>应用场景</b> <br />CTP制版。
                </p>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="fa1ea mob reveal-scaletop">
            <div class="swiper-container" id="swiper_fa2">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="fa1eb">
                    <div class="fa1eb_t">
                      <img src="@/view/images/y31.jpg" />
                      <p><span></span>FPS文件预检系统</p>
                    </div>
                    <div class="fa1eb_w">
                      <p>
                        PDF文件预检是指对各种印前排版文件在输出前进行必要的检查，通过预检环节，可在早期发现文件中的输出陷阱并及时修正错误，避免由于印前制作不规范等原因导致严重的印刷质量事故，造成无谓的损失。
                        <br /><b>应用场景</b>
                        <br />品牌商、客户、设计\排版人员、业务员、印前人员等
                        <br />
                        <br /><b>功能</b>
                        <br />自动、快速完成印刷文件的预检工作，保证印前文件质量，减少文件出错概率。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1eb">
                    <div class="fa1eb_t">
                      <img src="@/view/images/y32.jpg" />
                      <p><span></span>返单追样系统</p>
                    </div>
                    <div class="fa1eb_w">
                      <p>
                        返单追样系统是一套辅助印前作业人员快速实现追样的软件系统
                        <br />
                        <br /><b>应用场景</b>
                        <br />1）企业建立印刷规范后，原有产品的返（翻）单追色；
                        <br />2）非标准客户样的印刷追色；
                        <br />3）不同印刷机台的印刷追色；
                        <br />4）不同印刷工艺的印刷追色。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1eb">
                    <div class="fa1eb_t">
                      <img src="@/view/images/y33.jpg" />
                      <p><span></span>专色追色系统</p>
                    </div>
                    <div class="fa1eb_w">
                      <p>
                        专色追色系统用于精确分析因各种印刷工艺问题导致的颜色变化并进行色彩校正补偿的追色系统。<br /><br /><b
                          >应用场景</b
                        ><br />油墨干湿变化校正、专色追色校正、覆膜颜色变化校正、上光颜色变化校正。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1eb">
                    <div class="fa1eb_t">
                      <img src="@/view/images/y34.jpg" />
                      <p><span></span>印版网点扫描系统</p>
                    </div>
                    <div class="fa1eb_w">
                      <p>
                        印版网点扫描系统用于印前制版环节，主要用于CTP印版网点测控条的网点数据的快速测量。

                        <br /><b>特点</b>
                        <br />一次扫描快速完成批量网点数据测量，数据实时上云，实现云监控。
                      </p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1eb">
                    <div class="fa1eb_t">
                      <img src="@/view/images/y35.jpg" />
                      <p><span></span>印张质量采集系统</p>
                    </div>
                    <div class="fa1eb_w">
                      <p>
                        印版网点扫描系统用于印刷环节，主要用于对印刷样张上测控条色彩数据的快速采集，可用于评测手动放墨/CIP3自动放墨精度及印刷品是否满足特定印刷规范。

                        <br /><b>特点</b>
                        <br />5-10秒完成对开幅面的样张扫描，数据实时上云，实现云监控。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="fa1f">
        <div class="commen">
          <div class="bt reveal-scaletop">
            <h6>相关课程</h6>
            <img src="@/view/images/y8.png">
          </div>
          <div class="fa1fa pc reveal-scaletop solushow">
            <el-carousel class="cardShowban" height="450px" :loop="true" indicator-position="outside" :interval="3000" arrow="never">
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="lv">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="lv">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="lv">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="fa1fb">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="lv">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="fa1fa mob reveal-scaletop">
            <div class="swiper-container" id="swiper_fa3">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y36.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="lv">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y37.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="fa1fc fl">
                    <a href="#">
                      <div class="fa1fc_t">
                        <img src="@/view/images/y38.jpg">
                        <p>立即学习</p>
                      </div>
                      <div class="fa1fc_w">
                        <h6>印前色彩管理</h6>
                        <p>课程简介/达成能力/简单标语/课程内容等等......</p>
                        <h5 class="ju">免费</h5>
                        <span>6课时</span>
                        <div class="clearfix"></div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!--留言-->
    <!-- <div class="lyan reveal-scaletop">
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" type="text" value="您的公司" v-model="gongsi" onfocus="if(value=='您的公司') {value=''}"
                 onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" type="text" value="您的联系方式" v-model="mobile" onfocus="if(value=='您的联系方式') {value=''}"
                 onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" v-model="content" onfocus="if(value=='您的需求'){value=''}"
                    onblur="if (value ==''){value='您的需求'}">您的需求</textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
    <coun-sel></coun-sel>
  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0fb0c350f1482064e25902f9db8dec76";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
import $ from "jquery"; // 在需要使用的页面中
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import CounSel from "@/components/counsel";

export default {
  name: "solutionName",
  components: {
    CounSel
  },
  data() {
    return {
      content: "您的需求",
      mobile: "您的联系方式",
      gongsi: "您的公司"
    };
  },
  methods: {
    init() {},
    arrowClick(val) {
      if (val === "right") {
        this.$refs.fa1show.next();
      } else {
        this.$refs.fa1show.prev();
      }
    }
  },
  mounted() {
    new Swiper("#swiper_fa1", {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true
    });
    new Swiper("#swiper_fa2", {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true
    });
    new Swiper("#swiper_fa3", {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 20,
      centeredSlides: true
    });
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  }
};
</script>

<style scoped>
.fa1dc {
  width: 31%;
  margin: 0 1.1%;
}
.fa1da_an {
  margin-top: 20px;
}
.pc .bannericon {
  width: 1600px;
}

.pc .bka_a {
  width: 50%;
}
.fa1fb {
  display: block !important;
}
</style>
<style>
.solushow .el-carousel__indicators--horizontal {
  width: 100% !important;
  position: absolute !important;
  bottom: 0% !important;
  left: 0 !important;
  transform: translateX(0) !important;
  z-index: 99 !important;
  text-align: center;
}

.solushow .el-carousel__button {
  cursor: pointer;
  width: 7px;
  height: 7px;
  margin: 0 2.5px;
  float: left;
  position: relative;
  transition: all ease 0 0.35s;
  background-color: #1f232a;
  border-radius: 50%;
  opacity: 1;
  transition: all ease 0.35s;
}

.solushow .el-carousel__indicator.is-active button {
  background-color: #f6b415;
  width: 30px;
  border-radius: 20px;
}
.indent-text{
  text-indent: -15px;
}
.pd15 {
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/solution.vue